// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';
import { toggleImportDialog } from 'store/reducers/projectSettingsSlice';
import ImportProjectDialog from 'components/projectSelection/ImportProjectDialog';
import useAppPermissions from 'hooks/useAppPermissions';
import { Button } from '@tls/treact-ui';
import { IconSave } from '@tls/treact-ui/icons';

export default function ImportProjectButton() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { hasCreateCDProjectPermission, hasCreateQCProjectPermission } = useAppPermissions();

  const onOpen = useCallback(() => {
    dispatch(toggleImportDialog());
  }, [dispatch]);

  return (
    <>
      <Button
        icon={<IconSave />}
        variant='secondary'
        onClick={onOpen}
        className='fill'
        label={t('projects.importProject')}
        disabled={!hasCreateCDProjectPermission && !hasCreateQCProjectPermission}
        data-testid='projects-import-button'
      />
      <ImportProjectDialog />
    </>
  );
}
